export default "__VITE_ASSET__Evl7L3jn__"